import React from 'react';
import '../styles/Dashboard.css';

function Dashboard() {
  return (
    <div className="dashboard">
      <h2>Dashboard</h2>
      <div className="dashboard-content">
        <p>Welcome to your dashboard</p>
      </div>
    </div>
  );
}

export default Dashboard; 